import { useSuspenseQuery } from '@tanstack/react-query';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { mapUsageDTOtoAreaChartData } from 'src/common/utils/mapUsageDTOtoAreaChartData';
import { getDailyUsage } from '../api/detailsUsageApi';
import { detailsQueries } from '../queries/detailsQueries';
import { DetailsTypeValue } from '../UsageChartsSection';
import { useTranslation } from 'react-i18next';

type UseDetailsDailyUsageDataProps = {
  id: string;
  chartType: ChartTypeValue;
  usageType: UsageTypeValue;
  detailsType: DetailsTypeValue;
};

export const useDetailsDailyUsageData = ({
  id,
  chartType,
  usageType,
  detailsType,
}: UseDetailsDailyUsageDataProps) => {
  const { t } = useTranslation();
  const { data } = useSuspenseQuery<
    Awaited<ReturnType<typeof getDailyUsage>>,
    Error,
    ReturnType<typeof mapUsageDTOtoAreaChartData>
  >({
    queryKey: detailsQueries.dailyUsage({ id, chartType, usageType, detailsType }),
    queryFn: () => setMinimalPromiseTime(getDailyUsage({ id, chartType, usageType, detailsType })),
    select: (chartData) => mapUsageDTOtoAreaChartData(chartData, usageType, t),
  });

  return data;
};
